import React from "react";
import "fontsource-work-sans";
import { Tabs, Tab } from "@material-ui/core";
import { AboutMeComponent } from "../PageContents/AboutMeComponent";
import { EducationJobsComponent } from "../PageContents/Education&JobsComponent";
import { ProjectsComponent } from "../PageContents/ProjectsComponent";

export const PageSliderComponent = () => {
    const [selectedTab, setSelectedTab] = React.useState(0);
    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    }
    return (
        <div>
            <Tabs
                variant={"fullWidth"}
                value={selectedTab}
                onChange={handleChange}
                TabIndicatorProps={{style: {backgroundColor: '#007BFF'}}}
            >
                <Tab label="About me"
                     style={{
                         outline: "none",
                         fontFamily: "Work Sans",
                         textTransform: "none" }} />
                <Tab label="Jobs and Education"
                     style={{
                         outline: "none",
                         fontFamily: "Work Sans",
                         textTransform: "none" }} />
                <Tab label="Projects"
                     style={{
                         outline: "none",
                         fontFamily: "Work Sans",
                         textTransform: "none" }} />
            </Tabs>
            {selectedTab === 0 && <AboutMeComponent />}
            {selectedTab === 1 && <EducationJobsComponent />}
            {selectedTab === 2 && <ProjectsComponent />}
        </div>
    );
}
